import { Injectable } from '@angular/core';

import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { PickOddsState } from '../../../../../core/picks/pick-models';
import { GroupWithSuspendedLegsError } from '../../../errors/general/group-pick-error';
import { IPurePickValidator } from './validators';

@Injectable()
export class GroupPickWithSuspendedLegsValidator implements IPurePickValidator<GroupWithSuspendedLegsError> {
    validate(pick: BetslipPick): GroupWithSuspendedLegsError[] {
        if (BaseBetslipGroupPick.isPick(pick)) {
            const lockedLegs = pick
                .getLegs()
                .filter((l) => pick.getOddsStateForLegId(l.id) === PickOddsState.Locked)
                .map((l) => l.id);

            return lockedLegs.length > 0 ? [new GroupWithSuspendedLegsError(pick.id.toString(), lockedLegs)] : [];
        }

        return [];
    }
}
